(function (window, document) {
  'use strict';

  var P = window.Printara;
  if (!P) return;

  var COPY_SPACING = 0.25;

  function mode(calc) {
    var active = calc && calc.querySelector('.gk-tab.is-active');

    return active
      ? active.getAttribute('data-tab') || 'dimensions'
      : 'dimensions';
  }

  function readQuantity(input) {
    if (!input) return 2;

    var raw = String(input.value || '').trim();

    if (raw === '') return null;

    var quantity = parseInt(raw, 10);

    if (!isFinite(quantity)) return null;

    return Math.max(2, quantity);
  }

  function normalizeQuantity(input) {
    var quantity = readQuantity(input);

    if (quantity === null) {
      quantity = 2;
    }

    if (input) {
      input.value = String(quantity);
    }

    return quantity;
  }

  function quantityForState(input) {
    var quantity = readQuantity(input);

    return quantity === null
      ? 2
      : quantity;
  }

  function getState(calc) {
    if (!calc) {
      return {
        mode: 'dimensions',
        copyMode: 'single',
        copies: 1
      };
    }

    var currentMode = mode(calc);

    if (currentMode === 'squareFootage') {
      var sqftQuantityRadio = calc.querySelector(
        '[data-gk-sqft-copy-quantity-radio]'
      );

      if (sqftQuantityRadio && sqftQuantityRadio.checked) {
        return {
          mode: currentMode,
          copyMode: 'quantity',
          copies: quantityForState(
            calc.querySelector('[data-gk-sqft-copy-quantity]')
          )
        };
      }

      return {
        mode: currentMode,
        copyMode: 'single',
        copies: 1
      };
    }

    var quantityRadio = calc.querySelector('[data-gk-copy-quantity-radio]');

    if (quantityRadio && quantityRadio.checked) {
      return {
        mode: currentMode,
        copyMode: 'quantity',
        copies: quantityForState(
          calc.querySelector('[data-gk-copy-quantity]')
        )
      };
    }

    var fillRadio = calc.querySelector('[data-gk-copy-fill]');

    if (fillRadio && fillRadio.checked) {
      return {
        mode: currentMode,
        copyMode: 'fill',
        copies: Math.max(
          1,
          parseInt(fillRadio.dataset.maxCopies, 10) || 1
        )
      };
    }

    return {
      mode: currentMode,
      copyMode: 'single',
      copies: 1
    };
  }

  function syncProperty(calc) {
    if (!calc) return;

    var state = getState(calc);
    var hidden = calc.querySelector('[data-gk-copies-property]');

    if (hidden) {
      hidden.value = String(state.copies || 1);
    }

    P.forms.setPropertyAll('Copies', String(state.copies || 1), {
      marker: 'copies',
      disableWhenEmpty: false
    });
  }

  function updateVisibility(calc) {
    if (!calc) return;

    var currentMode = mode(calc);
    var width = P.util.parseNumber(
      calc.querySelector('[data-gk-file-width]') &&
      calc.querySelector('[data-gk-file-width]').value
    );
    var height = P.util.parseNumber(
      calc.querySelector('[data-gk-file-height]') &&
      calc.querySelector('[data-gk-file-height]').value
    );

    var dimensionCopies = calc.querySelector('[data-gk-dimension-copies]');

    var disabledForPaneling =
      calc.dataset.gkCopiesDisabledForPaneling === 'true';

    if (dimensionCopies) {
      dimensionCopies.hidden =
        disabledForPaneling ||
        !(width > 0 && height > 0);
    }

    var quantityWrap = calc.querySelector('[data-gk-copy-quantity-container]');
    var quantityRadio = calc.querySelector('[data-gk-copy-quantity-radio]');

    if (quantityWrap) {
      quantityWrap.hidden = !(
        currentMode === 'dimensions' &&
        quantityRadio &&
        quantityRadio.checked
      );
    }

    var sqftQuantityWrap = calc.querySelector(
      '[data-gk-sqft-copy-quantity-container]'
    );
    var sqftQuantityRadio = calc.querySelector(
      '[data-gk-sqft-copy-quantity-radio]'
    );

    if (sqftQuantityWrap) {
      sqftQuantityWrap.hidden = !(
        currentMode === 'squareFootage' &&
        sqftQuantityRadio &&
        sqftQuantityRadio.checked
      );
    }

    syncProperty(calc);
  }

  function setCopiesAvailability(calc, options) {
    if (!calc) return;

    options = options || {};

    var dimensionCopies =
      calc.querySelector('[data-gk-dimension-copies]');

    var panelingRequired =
      !!options.panelingRequired;

    calc.dataset.gkCopiesDisabledForPaneling =
      panelingRequired ? 'true' : 'false';

    if (dimensionCopies) {
      dimensionCopies.hidden = panelingRequired;
    }

    if (!panelingRequired) {
      var single =
        calc.querySelector('[data-gk-copy-single]');

      var fill =
        calc.querySelector('[data-gk-copy-fill]');

      var quantityRadio =
        calc.querySelector('[data-gk-copy-quantity-radio]');

      var quantityInput =
        calc.querySelector('[data-gk-copy-quantity]');

      if (single) single.disabled = false;
      if (fill) fill.disabled = false;
      if (quantityRadio) quantityRadio.disabled = false;
      if (quantityInput) quantityInput.disabled = false;

      calc
        .querySelectorAll('[data-gk-copy-step]')
        .forEach(function (button) {
          button.disabled = false;
        });

      updateVisibility(calc);
      return;
    }

    /*
     * Paneled jobs do not offer Copies.
     * Reset the UI and cart property so a quantity selected
     * before paneling was required cannot carry forward.
     */
    var single =
      calc.querySelector('[data-gk-copy-single]');

    var fill =
      calc.querySelector('[data-gk-copy-fill]');

    var quantityRadio =
      calc.querySelector('[data-gk-copy-quantity-radio]');

    var quantityInput =
      calc.querySelector('[data-gk-copy-quantity]');

    if (single) {
      single.checked = true;
      single.disabled = true;
    }

    if (fill) {
      fill.checked = false;
      fill.disabled = true;
    }

    if (quantityRadio) {
      quantityRadio.checked = false;
      quantityRadio.disabled = true;
    }

    if (quantityInput) {
      quantityInput.value = '2';
      quantityInput.disabled = true;
    }

    calc
      .querySelectorAll('[data-gk-copy-step]')
      .forEach(function (button) {
        button.disabled = true;
      });

    var hidden =
      calc.querySelector('[data-gk-copies-property]');

    if (hidden) {
      hidden.value = '1';
    }

    P.forms.setPropertyAll('Copies', '1', {
      marker: 'copies',
      disableWhenEmpty: false
    });

    var quantityWrap =
      calc.querySelector('[data-gk-copy-quantity-container]');

    if (quantityWrap) {
      quantityWrap.hidden = true;
    }
  }

  function setFillAvailability(calc, options) {
    if (!calc) return;

    options = options || {};

    var row = calc.querySelector('[data-gk-copy-fill-row]');
    var radio = calc.querySelector('[data-gk-copy-fill]');
    var single = calc.querySelector('[data-gk-copy-single]');
    var description = calc.querySelector('[data-gk-copy-fill-description]');

    if (!row || !radio) return;

    var maxCopies = Math.max(1, parseInt(options.maxCopies, 10) || 1);
    var unavailable = !!options.panelingRequired || maxCopies < 2;

    row.hidden = unavailable;

    if (unavailable) {
      radio.dataset.maxCopies = '';

      if (description) {
        description.textContent = '';
      }

      if (radio.checked) {
        radio.checked = false;
        if (single) single.checked = true;
      }

      syncProperty(calc);
      updateVisibility(calc);
      return;
    }

    radio.dataset.maxCopies = String(maxCopies);

    if (description) {
      description.textContent =
        'Approx. ' +
        maxCopies +
        ' copies within the same ' +
        P.util.formatNumber(options.squareFeet || 0) +
        ' sq ft.';
    }

    syncProperty(calc);
  }

  function getCopiesAcross(printAcross, mediaWidth) {
    var across = Number(printAcross);
    var usableWidth = P.productionOptions
      ? P.productionOptions.getUsableMediaWidth(mediaWidth)
      : Math.max(0, Number(mediaWidth) - 0.5);

    if (!isFinite(across) || across <= 0 || usableWidth <= 0) return 0;
    if (across > usableWidth) return 0;

    return Math.floor(
      (usableWidth + COPY_SPACING) /
      (across + COPY_SPACING)
    );
  }

  function emitUpdate(calc) {
    updateVisibility(calc);

    P.emit('printara:copies:update', {
      state: getState(calc),
      calculator: calc
    });
  }

  function initCalc(calc) {
    if (!calc || calc.dataset.printaraCopiesReady === 'true') return;

    calc.dataset.printaraCopiesReady = 'true';

    calc.addEventListener('input', function (event) {
      if (
        event.target.matches(
          '[data-gk-file-width], [data-gk-file-height], ' +
          '[data-gk-copy-quantity], [data-gk-sqft-copy-quantity]'
        )
      ) {
        updateVisibility(calc);
      }

      if (
        event.target.matches(
          '[data-gk-copy-quantity], [data-gk-sqft-copy-quantity]'
        )
      ) {
        /*
         * Allow the field to remain blank while the customer is
         * deleting the default value and typing a new quantity.
         */
        if (String(event.target.value || '').trim() === '') {
          return;
        }

        emitUpdate(calc);
      }
    });

    calc.addEventListener('change', function (event) {
      if (
        event.target.matches(
          '[data-gk-copy-quantity], [data-gk-sqft-copy-quantity]'
        )
      ) {
        normalizeQuantity(event.target);
        emitUpdate(calc);
        return;
      }

      if (
        event.target.matches(
          '[data-gk-copy-single], [data-gk-copy-fill], ' +
          '[data-gk-copy-quantity-radio], ' +
          '[data-gk-sqft-copy-single], [data-gk-sqft-copy-quantity-radio]'
        )
      ) {
        emitUpdate(calc);
      }
    });

    calc.addEventListener(
      'blur',
      function (event) {
        if (
          !event.target.matches(
            '[data-gk-copy-quantity], [data-gk-sqft-copy-quantity]'
          )
        ) {
          return;
        }

        normalizeQuantity(event.target);
        emitUpdate(calc);
      },
      true
    );

    calc.addEventListener('click', function (event) {
      var stepButton =
        event.target.closest &&
        event.target.closest('[data-gk-copy-step]');

      if (!stepButton || !calc.contains(stepButton)) return;

      var stepper = stepButton.closest('.gk-copy-stepper');
      if (!stepper) return;

      var input = stepper.querySelector(
        '[data-gk-copy-quantity], [data-gk-sqft-copy-quantity]'
      );

      if (!input || input.disabled) return;

      var current = readQuantity(input);

      if (current === null) {
        current = 2;
      }

      var delta =
        parseInt(stepButton.dataset.gkCopyStep, 10) || 0;

      var next = Math.max(2, current + delta);

      input.value = String(next);

      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    document.addEventListener('printara:calculator:mode', function (event) {
      if (!event.detail || event.detail.calculator === calc) {
        updateVisibility(calc);
      }
    });

    updateVisibility(calc);
  }

  function initAll() {
    document.querySelectorAll('[data-gk-calc]').forEach(initCalc);
  }

  P.copies = {
    COPY_SPACING: COPY_SPACING,
    getState: getState,
    syncProperty: syncProperty,
    updateVisibility: updateVisibility,
    setCopiesAvailability: setCopiesAvailability,
    setFillAvailability: setFillAvailability,
    getCopiesAcross: getCopiesAcross
  };

  P.util.ready(initAll);
  document.addEventListener('shopify:section:load', initAll);
})(window, document);
